'use client'
import FlagIcon from '@/app/icons/flag'
import Button from '@/components/button'
import { cn } from '@/util/cn'
import { Dispatch, ReactNode, SetStateAction, useRef, useState } from 'react'
import { useClickAway } from 'react-use'
import { useSearchCopy } from '@/context/site-chrome-copy'
import ReportSearch from '../report-search'

type Props = {
    label: string
    icon: ReactNode
    children: ReactNode[] | ReactNode
    isDisabled?: boolean
    setShow?: Dispatch<SetStateAction<boolean>>
    show?: boolean
}

const SearchFilter = ({ label, icon, children, isDisabled = false, show, setShow }: Props) => {
    const [showDropdown, setShowDropdown] = useState<Boolean>(false)
    // optionally hoist state
    const state = show !== undefined ? show : showDropdown
    const action = setShow !== undefined ? setShow : setShowDropdown
    const ref = useRef(null)
    useClickAway(ref, () => {
        setShowDropdown(false)
    })
    return (
        <div
            ref={ref}
            // min-w rather than a fixed w: the label is translated, and "Sort"
            // becoming "Ordenar" has to widen the button rather than squeeze
            // what is inside it. The dropdowns anchor to this box's left or
            // right edge, so a wider box does not move them.
            className={cn('relative flex h-10 min-w-24 flex-col', isDisabled && 'pointer-events-none opacity-50')}
        >
            <Button
                className="flex cursor-pointer items-center justify-center gap-2 rounded-sm bg-giphyDarkestGrey whitespace-nowrap"
                onClick={() => action(!state)}
            >
                {/* shrink-0 because an SVG is a flex item like any other: with
                    the default flex-shrink it collapses to nothing before the
                    text wraps, which is how the icons disappeared in Spanish. */}
                <span className="flex shrink-0 items-center">{icon}</span>
                {label}
            </Button>
            {state && <>{children}</>}
        </div>
    )
}

export const ReportButton = ({ type, term, gifResponseId }: { type: string; term: string; gifResponseId: string }) => {
    const [showModal, setShowModal] = useState<boolean>(false)
    const copy = useSearchCopy()
    return (
        <SearchFilter
            label={copy.report}
            icon={<FlagIcon className="size-4 [--stop-color-1:var(--giphy-red)] [--stop-color-2:var(--giphy-pink)]" />}
            show={showModal}
            setShow={setShowModal}
        >
            <ReportSearch
                type={type as 'stickers' | 'gifs'}
                searchTerm={term}
                onClose={setShowModal}
                gifResponseId={gifResponseId!}
            />
        </SearchFilter>
    )
}

export default SearchFilter
